import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** 우측 슬롯 (통계 카드, 액션 버튼 등) */
  right?: ReactNode;
}

/**
 * 페이지 상단 공통 헤더
 * - 모바일: 세로 스택, 데스크톱(lg~): 좌우 분할
 * - right 슬롯은 데스크톱에서 우측 상단에 배치
 */
export function PageHeader({ title, subtitle, right }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
      <div className="min-w-0">
        <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">{title}</h1>
        {subtitle && (
          <p className="mt-1 text-sm text-gray-600">{subtitle}</p>
        )}
      </div>
      {right && <div className="w-full lg:w-auto lg:max-w-[65%]">{right}</div>}
    </div>
  );
}
